<template>
    <div class="menu-container">
        <nav class="navbar navbar-expand-lg">
            <div class="container">
                <a class="navbar-brand d-block d-sm-none" :href="`/${def_lang}`">{{ G.projectName }}</a>

                <button
                    class="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarContent"
                    aria-controls="navbarContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <i class="fas fa-bars fs-1"></i>
                </button>

                <div class="collapse navbar-collapse" id="navbarContent">
                    <a :href="`/${def_lang}`" class="logo"><img :src="G.systemData?.logo?.value" alt="..." /></a>

                    <ul class="navbar-nav mt-2 mt-sm-0 me-auto d-flex-sm align-items-sm-center">
                        <MenuItem v-if="data.length > 0" :data="data[0]" />
                        <MenuItem :data="categories" />
                        <MenuItem v-for="item in data.slice(1)" :key="item.id" :data="item" />
                    </ul>

                    <!-- <div class="navbar-nav text-nowrap d-flex-sm align-items-sm-center">
                        <a
                            class="nav-link me-3 position-relative"
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasNavbar"
                            aria-controls="offcanvasNavbar"
                            aria-expanded="false"
                        >
                            <i class="far fa-heart"></i>
                            <span v-if="favorites.length" class="position-absolute badge top-0 start-1 bg-warning rounded-circle">
                                <span>{{ favorites.length || '' }}</span>
                                <span class="visually-hidden">Favorite</span>
                            </span>
                        </a>

                    </div> -->

                    <div class="col-12 col-lg-3 mb-3 mb-lg-0 me-lg-3 ms-md-3">
                        <div class="input-group">
                            <input
                                v-model="searchText"
                                type="search"
                                class="form-control form-sm-control"
                                :placeholder="TR.search"
                                aria-label="Search"
                                @keyup="onInputEnter"
                            />
                            <button @click="searchButton" class="btn btn-secondary bg-site">
                                <i class="fas fa-search"></i>
                            </button>
                        </div>
                    </div>

                    <div v-if="langs.length > 1" class="navbar-nav dropdown text-end1 mb-3 mb-lg-0 ms-sm-3">
                        <a href="#" class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                            {{ $route.params.lang !== undefined ? langs.filter(e => e.shortname == $route.params.lang)[0].flag : '' }}
                            {{ $route.params.lang !== undefined ? $route.params.lang : '' }}
                        </a>
                        <ul class="dropdown-menu" style="">
                            <li class="nav-item" v-for="(l, lind) in langs" :key="lind">
                                <a class="nav-link ps-3 cursor-pointer" @click="changeLang(l.shortname)">{{ l.flag }} {{ l.shortname }}</a>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </nav>
    </div>
</template>


<script>
    import { ref } from "vue";

    import { useRoute, useRouter } from "vue-router";
    import { useStore } from "@/system_modules/store";

    import { G } from "@/_common";

    import MenuItem from './MenuItem';

    export default {
        name: "NavbarC",
        components: {
            MenuItem,
        },
        props:{
            categories:{
                type: Object,
                default: () => {}
            },
            data:{
                type: Array,
                default: () => []
            },
            favorites:{
                type: Array,
                default: () => []
            },
            TR:{
                type: Object,
                default: () => {}
            },
            langs:{
                type: Array,
                default: () => []
            },
        },
        setup() {
            const store = useStore();
            const route = useRoute();
            const router = useRouter();

            const def_lang = store.getLang();

            const searchText = ref("");

            searchText.value = route.params && route.params.search_text && route.params.search_text != '0' ? route.params.search_text : '';

            const changeLang = (lang) => {
                // const result = text.replace(/B/g, match => ++t === 2 ? 'Z' : match)
                window.location.href = '//' + window.location.host + '' + route.path.replace(/^\/([a-z]{2})(\/)?/, `/${lang}$2`);
            };

            const searchButton = () => {
                if( searchText.value.length > 1 ){
                    router.push({
                        name: 'products_by_page',
                        params: {
                            page: 1,
                            perpage: 20,
                            category_id: 0,
                            year_min: 2025,
                            year_max: 2025,
                            quarters: 0,
                            price_min: 0,
                            price_max: 0,
                            sortfield: 'name',
                            sortorder: 1,
                            filters: '0',
                            search_text: searchText.value,
                        },
                        // query: {
                        //     search_text: searchText.value,
                        // }
                    });
                }
            };

            const onInputEnter = (e) => {
                if (e.which == 13) {
                    searchButton();
                }
            };

            return {
                G,
                def_lang,
                changeLang,
                searchText,
                searchButton,
                onInputEnter,
            };
        },
    };
</script>

<style lang="scss" scoped>
// .menu-container{
//     // background-color: #ffffff;
//     // height: 100px;
// }
.menu-container .navbar {
    position: fixed;
    z-index: 1000;
    width: 100%;
    // background-color: transparent;
    // height: 100px;
    transition: height 0.3s, background-color 0.3s;
}
.menu-container .logo img {
    height: 80px;
    margin-right: 40px;
    transition: height 0.3s;
}
.menu-container.fix-menu-container .navbar{
    // height: 60px;
    background-color: #ffffff;
    border-bottom: 1px solid var(--default-color);
}
.menu-container.fix-menu-container .logo img{
    height: 60px;
}
@media (max-width: 576px) {
    .menu-container{
        background-color: #ffffff;
        height: 60px;
    }
    .menu-container.fix-menu-container .navbar{
        // height: 60px;
        background-color: unset;
        border-bottom: unset;
    }
    // .menu-container.fix-menu-container .logo img{
    //     height: unset;
    // }
    .menu-container .navbar{
        // position: relative;
        height: 60px;
        position: relative;
        // z-index: 1000;
        width: 100%;
    }
    .menu-container .navbar .container{
        background-color: #ffffff;
    }
    .menu-container .logo img {
        transition: none;
        height: 60px;
    }
//     .menu-container.fix-menu-container .navbar .container{
//         background-color: #ffffff;
//     }
}
</style>
